class EnvVars {
  private vars: { [key: string]: string } = {};

  public constructor(data: { [key: string]: string | undefined }) {
    this.setVars(data);
  }

  public setVars(data: { [key: string]: string | undefined }): void {
    for (const [name, value] of Object.entries(data)) {
      if (name.startsWith("VUE_APP_")) {
        this.vars[name] = value ? value : "";
      }
    }
  }

  public has(name: string): boolean {
    return this.vars.hasOwnProperty(name);
  }

  public get(name: string, defaultValue: string | undefined = undefined): string | undefined {
    return this.vars.hasOwnProperty(name) ? this.vars[name] : defaultValue;
  }

  public getStr(name: string, defaultValue: string = ""): string {
    return this.vars.hasOwnProperty(name) ? String(this.vars[name]) : defaultValue;
  }

  public getInt(name: string, defaultValue: number = 0): number {
    return this.vars.hasOwnProperty(name) ? parseInt(this.vars[name]) : defaultValue;
  }

  public getNumber(name: string, defaultValue: number = 0): number {
    return this.vars.hasOwnProperty(name)
      ? parseFloat(this.vars[name])
      : defaultValue;
  }

  public getBool(name: string, defaultValue: boolean = false): boolean {
    if (this.vars.hasOwnProperty(name)) {
      const value: string = this.vars[name].toLowerCase();

      if (["1", "true", "yes", "y"].includes(value)) {
        return true;
      }

      if (["0", "false", "no", "n"].includes(value)) {
        return false;
      }
    }

    return defaultValue;
  }
}

export const envVars = new EnvVars(process.env);
